













































import { Component, Vue, Watch, Prop} from 'vue-property-decorator';
import { JobDetailsModule } from '@/store/modules/jobDetails';
import GiganautVue from '@/components/Shared/GiganautVue';
import JobWorkerDto from '@/models/JobWorkers/JobWorkerDto';
import JobWorker from '@/components/JobWorkers/JobWorker.vue'
import JobWorkerStatus from '@/components/JobWorkers/Display/JobWorkerStatus.vue'
import JobWorkerStatusEnum from '@/models/JobWorkers/JobWorkerStatus';

@Component({
  name: 'JobShortlistedWorkers',
  components: { JobWorker, JobWorkerStatus }
})
export default class extends GiganautVue {

	jobWorkerStatusEnum = JobWorkerStatusEnum;
	page = 1;
	perPage = 8;

	get selectedJobWorker() {
		return JobDetailsModule.jobWorkersVM.selectedShortlistedJobWorker;
	}

	set selectedJobWorker(value: JobWorkerDto) {
		JobDetailsModule.jobWorkersVM.selectedWorkerId = value.workerId;
		JobDetailsModule.jobWorkersVM.selectedShortlistedJobWorker = value;
	}
	get currentJob() {
		return JobDetailsModule.currentJob;
	}
	
	get jobWorkers() {
		return JobDetailsModule.jobWorkersVM.jobWorkers;
	}

	get pagedJobWorkers() {
		return this.shortlistedWorkers.slice((this.page - 1)* this.perPage, this.page* this.perPage)
	}

	get shortlistedWorkers() {
		return this.jobWorkers.filter((jobWorker) => (
			jobWorker.status === JobWorkerStatusEnum.SentToWorker || 
			jobWorker.status === JobWorkerStatusEnum.Shortlisted
			))
	}
	
	async onPageChanged(input: number){
		JobDetailsModule.jobWorkersVM.selectedShortlistedJobWorker = (this.pagedJobWorkers[0]);
	}

	get loadingWorkers() {
		return JobDetailsModule.loadingWorkers;
	}

	async updateSelectedWorkerIds(val: boolean, workerId: string) {
    	if (val) {
			//await JobDetailsModule.addBrowseSelectedWorkerId(workerProfileId)
		} else {
			//await JobDetailsModule.removeBrowseSelectedWorkerId(workerProfileId)
		}
	}
}
